import { z } from 'zod';

import { BorrowerId } from '../../../BrandedIds';
import { RepaymentWorkoutPlan } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CreateRepaymentWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('createRepaymentWorkoutPlan'),
  data: RepaymentWorkoutPlan.pick({
    startDate: true,
    startStatementDate: true,
    endStatementDate: true,
    termMonths: true,
    hasFees: true,
    workflowInformation: true,
  }).extend({
    sendAgreementTo: z.array(BorrowerId),
    quotedDetails: z.object({
      arrearageTotal: z.number().nonnegative(),
      arrearageBilledPerStatement: z.number().nonnegative(),
      contractualMonthlyPaymentAmount: z.number().nonnegative(),
      planMonthlyPaymentAmount: z.number().nonnegative(),
      planIncrease: z.number(),
    }),
  }),
});
export type CreateRepaymentWorkoutPlanEvent = z.infer<typeof CreateRepaymentWorkoutPlanEvent>;
